import { FC, HTMLAttributes } from "react";
import Image from "next/image";
import icon, { IIconName } from "@/utils/icon.helper";
import TButton from "../atoms/buttons/TButton";
import { ITextButton } from "../atoms/buttons/types";
import clsx from "clsx";
// -----------------------------------------------------------------------------------------

export type ICaseStudyCard = {
  image?: { src: string; alt: string };
  icon?: IIconName;
  heading?: string;
  button?: ITextButton;
};

export type ICaseStudyCardProps = HTMLAttributes<HTMLDivElement> &
  ICaseStudyCard & {};

const CaseStudyCard: FC<ICaseStudyCardProps> = (props) => {
  const { heading, icon: cardIcon, image, button, className, ...other } = props;

  return (
    <div
      className={clsx(
        "group h-full bg-white transition-all duration-[600ms] ease-in-out hover:bg-primary-900",
        className,
      )}
      {...other}
    >
      {image && (
        <div className="h-[210px] w-auto lg:h-[180px] xl:h-[228px]">
          <Image
            src={image.src}
            className="!h-full w-full object-cover"
            alt={image.alt}
            height={228}
            width={379}
          />
        </div>
      )}

      <div className="relative min-h-36 px-3 py-4 md:min-h-40 md:px-5 md:py-6 lg:min-h-[172px] xl:min-h-[189px]">
        <div className="mb-4 size-8 opacity-100 transition-opacity duration-[600ms] ease-out group-hover:opacity-0 lg:mb-5 lg:size-11 xl:mb-6">
          {cardIcon && (
            <Image
              src={icon(cardIcon)}
              alt={cardIcon}
              height={44}
              width={44}
              className="size-full"
            />
          )}
        </div>
        <div className="translate-y-0 transition-all duration-[600ms] ease-out group-hover:-translate-y-10 md:group-hover:-translate-y-[52px] lg:group-hover:-translate-y-[74px]">
          {heading && (
            <h2 className="line-clamp-2 text-lg font-medium text-black-900 transition-all duration-[600ms] ease-out group-hover:text-white lg:text-h6 xl:text-h5">
              {heading}
            </h2>
          )}
        </div>
        {button && (
          <TButton
            id={button.id}
            className="absolute bottom-0 my-4 opacity-0 transition-opacity duration-[600ms] ease-out group-hover:opacity-100 md:my-6"
            variant={button.variant}
            href={button.link}
            target={button.target}
            radius={button.radius}
          >
            {button.text}
          </TButton>
        )}
      </div>
    </div>
  );
};

export default CaseStudyCard;
